export default __webpack_public_path__ + "static/media/cover (8).d2d74670.svg";